import React from 'react';
import { formatNumber } from '../types';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  trend?: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, subtitle, trend }) => (
  <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 hover:bg-white/10 hover:border-[#FF9C15]/30 transition-all duration-300">
    <p className="text-xs font-medium text-gray-400 uppercase tracking-wider">{title}</p>
    <p className="text-2xl font-bold text-white mt-1">
      {typeof value === 'number' ? formatNumber(value) : value}
    </p>
    <div className="flex items-center gap-2 mt-1">
      {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
      {trend && (
        <span
          className={`text-xs font-medium px-2 py-0.5 rounded-full ${
            parseFloat(trend) >= 0
              ? 'bg-emerald-500/10 text-emerald-400'
              : 'bg-red-500/10 text-red-400'
          }`}
        >
          {parseFloat(trend) >= 0 ? '+' : ''}
          {trend}%
        </span>
      )}
    </div>
  </div>
);

export default StatCard;
